import {Component, Inject} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from '@angular/material/dialog';
import {MatButton} from "@angular/material/button";
import {FormsModule} from "@angular/forms"; // Using Angular Material Dialog

export interface HtmlEditData {
    html: string;
}

@Component({
    selector: 'app-html-edit-modal',
    template: `
        <h2 mat-dialog-title>Edit HTML Source</h2>
        <mat-dialog-content class="mat-typography">
            <textarea [(ngModel)]="data.html" rows="20" style="width: 100%; font-family: monospace;"></textarea>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-button (click)="onNoClick()">Cancel</button>
            <button mat-button [mat-dialog-close]="data.html" cdkFocusInitial color="primary">Apply</button>
        </mat-dialog-actions>
    `,
    imports: [
        MatDialogActions,
        MatDialogContent,
        MatButton,
        MatDialogClose,
        MatDialogTitle,
        FormsModule
    ],
    standalone: true
})
export class HtmlEditModalComponent {
    constructor(
        public dialogRef: MatDialogRef<HtmlEditModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: HtmlEditData,
    ) {}

    onNoClick(): void {
        this.dialogRef.close();
    }
}
